export default __webpack_public_path__ + "static/media/previous_expo_2019 (11).a5a21c57.jpg";